import Modal from '@components/App/Modal/Modal'
import NotificationWrapper from '@components/App/NotificationContainer/NotificationWrapper'
import { PromoReport as Promo } from '@components/App/PromoReport'
import Theme from '@components/ArtBoard/Theme/Theme'
import type React from 'react'
import { useSelector } from 'react-redux'

import { selectIsLoading } from '@/store'

// Handoff route for the generator page's List view card (route /promo-report).
// Open to a guest, like the visual handoff: the report is created without an
// owner and the guest saves it from the report's header. Who is asking still
// has to be known first — a signed-in visitor's report is theirs at once.
export const PromoReport: React.FC = () => {
  const checkingAuth = useSelector(selectIsLoading('authentication'))

  return (
    <Theme>
      <NotificationWrapper />
      {!checkingAuth && <Promo />}
      <Modal />
    </Theme>
  )
}
